<div class="flex flex-col gap-4">
  <div>
    <div class="grid grid-cols-1 md:grid-cols-6 gap-3">
      <div class="flex flex-col md:col-span-5">
        <label class="soft-label required top" for="item">Artikel</label>
        <soft-field-ok
          fieldOkName="artstamm"
          placeholder="Artikelnummer oder Bezeichnung"
          [(value)]="currentItem"
        />
      </div>
      <div class="flex flex-col">
        <label class="soft-label required top" for="quantity">Anzahl</label>
        @if (currentItem()) {
          <soft-number-input
            [(value)]="currentQuantity"
            [allowNegative]="true"
            changeTrigger="input"
            [style.--soft-number-input-text]="negativeColor(currentQuantity())"
            placeholder="Anzahl"
          />
        } @else {
          <soft-input [readonly]="true" placeholder="1" />
        }
      </div>
      <div class="flex flex-col md:col-span-2">
        <label class="soft-label top" for="discount">Rabatt %</label>
        @if (currentItem()) {
          <soft-number-input
            [(value)]="currentDiscount"
            [readonly]="!currentItem() || !changePriceAndDiscount()"
            [style.--soft-number-input-text]="negativeColor(currentDiscount())"
            placeholder="0"
          />
        } @else {
          <soft-number-input [readonly]="true" placeholder="0" />
        }
      </div>
      <div class="flex flex-col md:col-span-2">
        <label class="soft-label top required" for="price">Preis</label>
        @if (currentItem()) {
          <soft-number-input
            [(value)]="currentPricePerUnit"
            [readonly]="!currentItem() || !changePriceAndDiscount()"
            [style.--soft-number-input-text]="negativeColor(currentPricePerUnit())"
            placeholder="0,00"
          />
        } @else {
          <soft-number-input [readonly]="true" placeholder="0,00" />
        }
      </div>
      <div class="flex flex-col md:col-span-2">
        <label class="soft-label top" for="lastPurchasePrice">Letzter EK-Preis</label>
        <soft-number-input
          [readonly]="true"
          [(value)]="currentLastEkPrice"
          [style.--soft-number-input-text]="negativeColor(currentLastEkPrice())"
          placeholder="—"
        />
      </div>
      <div class="flex flex-col md:col-span-2">
        <label class="soft-label top" for="total">Gesamt</label>
        <soft-number-input
          [readonly]="true"
          [(value)]="currentPrice"
          [style.--soft-number-input-text]="negativeColor(currentPrice())"
          placeholder="0,00"
        />
      </div>
    </div>
    <div class="mt-3 flex items-center justify-between gap-2">
      <soft-ds-switch
        [(value)]="combineSameProduct"
        label="Gleiche Artikel zusammenfassen"
        controlPlacement="start"
        data-testid="order-item-combine-toggle"
      />
      <div class="flex items-center gap-2">
        @if (isEditing()) {
          <soft-ds-button
            variant="outline"
            size="lg"
            [disabled]="saving()"
            (click)="cancelEdit()"
            data-testid="order-item-cancel-edit"
          >
            Abbrechen
            <ng-template softSlot="leading">
              <soft-ds-icon name="fa-regular fa-xmark" />
            </ng-template>
          </soft-ds-button>
        } @else {
          <soft-ds-button
            variant="outline"
            mode="iconOnly"
            size="lg"
            [disabled]="saving()"
            (click)="startScan()"
            ariaLabel="Artikel scannen"
            data-testid="order-item-scan"
          >
            <soft-ds-icon name="fa-regular fa-barcode-read" />
          </soft-ds-button>
        }
        <soft-ds-button
          [variant]="buttonVariant()"
          size="lg"
          [disabled]="!currentItem()"
          [loading]="saving()"
          (click)="addItem()"
          data-testid="order-item-add"
        >
          {{ isEditing() ? 'Speichern' : 'Hinzufügen' }}
          <ng-template softSlot="leading">
            <soft-ds-icon
              [name]="isEditing() ? 'fa-regular fa-floppy-disk' : 'fa-regular fa-plus'"
            />
          </ng-template>
        </soft-ds-button>
      </div>
    </div>
  </div>
  @if (items().length > 0) {
    <div class="flex flex-col gap-3">
      @for (item of items(); track item.id ?? item.product.id; let i = $index) {
        <div
          class="flex items-center gap-2 p-2 border dark:border-gray-800 rounded-lg"
          data-testid="order-item-row"
        >
          <span
            class="shrink-0 w-5 text-sm tabular-nums text-gray-400 dark:text-gray-500 text-center"
          >
            {{ i + 1 }}
          </span>
          <div class="flex flex-col min-w-0 flex-1">
            <div class="flex items-center gap-2 min-w-0">
              <span
                class="line-clamp-1 text-xs font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400"
              >
                {{ item.product.number }}
              </span>
            </div>
            <span class="line-clamp-1 font-semibold text-gray-900 dark:text-gray-100">
              {{ item.product.name }}
            </span>
          </div>
          <div class="flex flex-col items-end shrink-0">
            <span class="font-semibold text-gray-900 dark:text-gray-100">
              {{ item.price.price | number: '1.2-2' }} €
            </span>
            <span class="text-xs text-gray-500 dark:text-gray-400 tabular-nums">
              {{ item.quantity | number: '1.0-2' }} ×
              {{ item.price.pricePerUnit | number: '1.2-2' }} €
            </span>
          </div>
          <div class="flex items-center gap-1 shrink-0">
            <soft-ds-button
              variant="outline"
              mode="iconOnly"
              size="md"
              (click)="editItem(item)"
              ariaLabel="Bearbeiten"
            >
              <soft-ds-icon
                name="fa-regular fa-pen"
                class="text-gray-500 dark:text-gray-400"
              />
            </soft-ds-button>
            <soft-ds-button
              variant="outline"
              mode="iconOnly"
              size="md"
              (click)="removeItem(item)"
              ariaLabel="Entfernen"
            >
              <soft-ds-icon
                name="fa-regular fa-trash"
                class="text-red-600 dark:text-red-400"
              />
            </soft-ds-button>
          </div>
        </div>
      }
      <div
        class="mt-4 pt-3 border-t border-gray-200 dark:border-gray-700 flex flex-col items-end"
      >
        <span class="text-xs text-gray-500 dark:text-gray-400">
          {{ items().length }} {{ items().length === 1 ? 'Position' : 'Positionen' }} ·
          Netto
        </span>
        <span class="text-xl font-bold" [style]="accentColorStyle()">
          {{ netTotal() | number: '1.2-2' }} €
        </span>
      </div>
    </div>
  } @else {
    <soft-ds-empty-state
      variant="empty"
      icon="fa-regular fa-box-open"
      title="Keine Artikel erfasst"
      description="Wähle oben einen Artikel und füge ihn hinzu."
      data-testid="order-items-empty-state"
    />
  }
</div>
